module.exports = __webpack_public_path__ + "static/hero-4a773b4474caf329e82855364f1237ab.jpg";